import React, { useContext, useState } from 'react';
import { Button, CancellationNoShowPolicyModal, Text } from '@rivallapp/volosports-components';
import { Checkbox } from '../../../../components/fancyFieldsV2';
import { RegistrationContext } from '../../../../contexts';
import { RegistrationActions } from '../../../../contexts/RegistrationContext/RegistrationReducer';

const CancellationPolicyWaiver: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  // @ts-expect-error - RegistrationContext doesn't have a TS type
  const [registerState, registerDispatch] = useContext(RegistrationContext);
  const { cancellationPolicyAgreed } = registerState;

  const handleCheckboxPress = (cancellationPolicyAgreed: boolean) => {
    registerDispatch({
      type: RegistrationActions.UPDATE_REGISTRATION_STATE,
      update: {
        cancellationPolicyAgreed,
      },
    });
  };

  return (
    <>
      <CancellationNoShowPolicyModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
      <Checkbox
        noLabel
        value={cancellationPolicyAgreed}
        onChange={(val: boolean) => handleCheckboxPress(val)}
      />
      <Text color="#FFFFFF" fontSize="14px">
        By joining you agree to our{' '}
        <Button
          variant="link"
          onPress={() => setIsOpen(true)}
          display="inline"
          p="0"
          m="0"
          _text={{ display: 'inline', fontSize: '14px' }}
        >
          Cancellation + No-show Policy
        </Button>
        .
      </Text>
    </>
  );
};

export default CancellationPolicyWaiver;
